import { alertsApi , archivalSearchApi } from "../../../api/apiClient";


function getInternalAlerts() {
    return alertsApi.get("/alerts/settings")
  }

  function getMessageTypes() {
    return alertsApi.get("/shared/message-types")

  }

  function getTemplates() {
    return alertsApi.get("/alerts/templates")
  }
  
  function getcurrency() {
    return archivalSearchApi.get("/shared/currencies")
  }

  function updateCriteria(data)
  {
    return alertsApi.put(`/alerts/settings/${data.id}`,data)
  }
  
  function deleteCriteria(data)
  {
    return alertsApi.delete(`/alerts/settings/${data.id}`)
  }
  function createCriteria(data)
  {
    return alertsApi.post(`/alerts/settings`,data)
  }

  function getFields(data)
  {
    return alertsApi.get(`/shared/message-types/${data.id}`)
  }
  export const internalAlertService = { 
    getInternalAlerts,
    getMessageTypes,
    getTemplates,
    getcurrency,
    updateCriteria,
    createCriteria,
    deleteCriteria,
    getFields

  };
